export const locale = {
    lang: 'ar',
    data: {
        EXPORT_BOARD: 'تصدير الى اللوحة',
        EXPORT: 'تصدير',
        SAVE: 'إلغاء',
    }
};
